module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-16.a3264e0e.png";